<template>
  <div style="display: inline-flex; position: absolute;right:34px; top: 0px">
    <mu-raised-button
      label-position="before"
      :label="$t('message.graphPointsToggleTitle')"
      icon="arrow_drop_down"
      class="opaque"
      :disabled="isDisabled"
      ref="button"
      @click.native="toggle"
    >
    </mu-raised-button>
    <mu-popover :scroller="scroller" :trigger="trigger" :open="open" @close="handleClose" :anchorOrigin="anchorOrigin" :targetOrigin="targetOrigin">
      <mu-list style="min-width: 180px">
        <mu-sub-header>{{$t('message.graphPointsToggleTitle')}}
          <mu-icon-button @click.native="toggle" style="float:right" icon="arrow_drop_up"></mu-icon-button>
        </mu-sub-header>
        <mu-divider></mu-divider>
        <mu-list-item disableRipple @click.native="handleToggle('showPoints')" :title="$t('message.graphPointToggleShowPoints')">
          <mu-switch v-model="showPoints" slot="right"/>
        </mu-list-item>
      </mu-list>
    </mu-popover>
  </div>
</template>
<script>
  import ScrollerMixin from '../../../mixins/ScrollerMixin'
  import MuRaisedButton from "muse-ui/src/raisedButton/raisedButton";
  export default {
    components: {MuRaisedButton},
    name: "graph-point-toggle",
    mixins:[ScrollerMixin],
    props: {
      isDisabled: true
    },
    data() {
      return{
        showPoints:false,
        open: false,
        trigger: null,
        anchorOrigin: {"vertical":"bottom","horizontal":"left"},
        targetOrigin: {"vertical":"middle","horizontal":"left"}
      }
    },
    watch: {
      'showPoints': function () {
        let self = this;
        if(self.showPoints === true) {
          self.$store.commit('showGraphPoints', true)
        }
        else {
          self.$store.commit('showGraphPoints', false)
        }
      }
    },
    mounted() {
      this.trigger = this.$refs.button.$el;
      let self = this;
      self.showPoints = self.$store.state.graphOptions.showDots
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      handleClose (e) {
        this.open = false
      },
      handleToggle (key) {
        this[key] = !this[key]

      }
    }
  }
</script>
<style lang="less">
  button.mu-icon-button.opaque {
    background: rgba(255, 255, 255, 0.31);
      .material-icons {
        color: #484848 !important;
      }
  }
</style>



// WEBPACK FOOTER //
// graph-point-toggle.vue?782357e0